registerGlobal( 'EmscriptenDeepLink' );
EmscriptenDeepLink.initData = {};

require( 'branch-sdk' );

EmscriptenDeepLink.initialize = function( scheme ) {
    console.log("Initializing DeepLink with apiKey", EmscriptenDeepLink.apiKey);
    branch.init( EmscriptenDeepLink.apiKey , function(err, data) {
        if(err) {
            console.log("Unable to initialize EmscriptenDeepLink.js");
        }
        else {
            EmscriptenDeepLink.initData = data;
            branch.setIdentity( FB.getUserID() );
            //Won't work when called right away
            if( data.data !== null && data.data.length != 0 ) {
                var resp = scheme + "://?branch_data:" + data.data;
                setTimeout( function() { Module.EmscriptenBranchOnDeepLinkReceived( resp ); }, 2500 );
            }
        }
    });
};

EmscriptenDeepLink.logout = function() {
    branch.logout();
}

EmscriptenDeepLink.getLatestReferringParams = function() {
    console.log("EmscriptenDeepLink.getLatestReferringParams()", EmscriptenDeepLink.initData.data );
    return EmscriptenDeepLink.initData.data;
};

EmscriptenDeepLink.trackEvent = function( event_name, params ) {
    var meta = undefined;
    if( params )
        meta = JSON.parse( params );
    branch.track( event_name, meta);
}



//////////////////
// WEBPACK FOOTER
// /src/contrib/branchio/emscripten/js/Application.branch.js
// module id = 27
// module chunks = 0